import { render } from "./TradePairToggle.vue?vue&type=template&id=71d29c1e&scoped=true"
import script from "./TradePairToggle.vue?vue&type=script&lang=ts"
export * from "./TradePairToggle.vue?vue&type=script&lang=ts"

import "./TradePairToggle.vue?vue&type=style&index=0&id=71d29c1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71d29c1e"

export default script